/**
 * browserIconSingleton.js
 * Created by Destin Frasier on 11/20/18.
 */

import { IconSingleton } from '../iconSingleton';

class BrowserIconSingleton extends IconSingleton {
    constructor() {
        super();

        this.notificationName = 'icons-browser.loaded';
        this.svgPath = `${process.env.CDN}/graphics/browserIcons.svg`;
    }
}

const instance = new BrowserIconSingleton();
export default instance;
